import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit'
export interface UserProgramSessionItem {
  appointment_id: string
  program_id: string
  type: 'program' | 'event'
  participants: {
    id: string
    status: 'waitlist' | 'reserved'
  }[]
}


export interface UserEventSessionItem {
  appointment_id: string
  program_id: string
  type: 'event'
  participants: {
    id: string
    status: 'waitlist' | 'reserved'
  }[]
}

export interface UserSessionProgramChildren {
  id: string
  num_of_programs_enrolled: number
}

export interface UserSessionEventChildren {
  id: string
  num_of_events_enrolled: number
}

export interface UserSession {
  id: string
  auth_session_id: string
  user_id: string
  program_enrollment: {
    date_started: string
    expires_in: string
    status?: string
    programs: UserProgramSessionItem[]
  }
  event_enrollment: {
    date_started: string
    expires_in: string
    status?: string
    events: UserEventSessionItem[]
  }
  num_of_programs_enrolled: number
  children_program_enrollment: UserSessionProgramChildren[]
  children_event_enrollment: UserSessionEventChildren[]
  status: string
  created_date: string
  updated_date: string
}

export const initialState: UserSession = {
  id: '',
  auth_session_id: '',
  user_id: '',
  created_date: '',
  updated_date: '',
  status: '',
  num_of_programs_enrolled: 0,
  children_program_enrollment: [],
  children_event_enrollment: [],
  program_enrollment: {
    date_started: '',
    expires_in: '',
    status: '',
    programs: [],
  },
  event_enrollment: {
    date_started: '',
    expires_in: '',
    status: '',
    events: [],
  },
}

export function getEmptyUserSession(): UserSession {
  return {
    id: '',
    auth_session_id: '',
    user_id: '',
    created_date: '',
    updated_date: '',
    status: '',
    num_of_programs_enrolled: 0,
    children_program_enrollment: [],
    children_event_enrollment: [],
    program_enrollment: {
      date_started: '',
      expires_in: '',
      status: '',
      programs: [],
    },
   event_enrollment: {
      date_started: '',
      expires_in: '',
      status: '',
      events: [],
    },
  }
}

const user_session = createSlice({
  name: 'user_session',
  initialState,
  reducers: {
    setUserSession(state, action: PayloadAction<UserSession>) {
      state.id = action.payload.id
      state.auth_session_id = action.payload.auth_session_id
      state.user_id = action.payload.user_id
      state.created_date = action.payload.created_date
      state.updated_date = action.payload.updated_date
      state.status = action.payload.status
      state.children_program_enrollment = action.payload.children_program_enrollment
      state.children_event_enrollment = action.payload.children_event_enrollment
      state.num_of_programs_enrolled = action.payload.num_of_programs_enrolled
      state.program_enrollment = action.payload.program_enrollment
      state.event_enrollment = action.payload.event_enrollment
    },
  },
})

export const getUserSession = createAction('user_session/getUserSession')
export const { setUserSession } = user_session.actions

export default user_session.reducer
